// Dependencias
import Api from '@/services/Api'
// methods
export default {
  fetchAccounts (token) {
    return Api().get('accounts', {headers: {'Content-Type': 'multipart/form-dataapplication/x-www-form-urlencoded', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  fetchAccounts2 (token) {
    return Api().get('accounts2', {headers: {'Content-Type': 'multipart/form-dataapplication/x-www-form-urlencoded', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  balance (token) {
    return Api().get('accounts/balance', {headers: {'Content-Type': 'multipart/form-dataapplication/x-www-form-urlencoded', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  filter (params, token) {
    return Api().get('accounts/filter/' + params, {headers: {'Content-Type': 'multipart/form-dataapplication/x-www-form-urlencoded', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  addAccount (params, token) {
    return Api().post('accounts', params, {headers: {'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  getAccount (params, token) {
    return Api().get('accounts/' + params.id, {headers: {'Content-Type': 'multipart/form-dataapplication/x-www-form-urlencoded', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  editAccount (params, token) {
    return Api().put('accounts/' + params.id, params, {headers: {'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  },
  delAccount (params, token) {
    return Api().delete('accounts/' + params.id, {headers: {'Content-Type': 'multipart/form-dataapplication/x-www-form-urlencoded', 'Accept': 'application/json', 'Authorization': 'Bearer ' + token}})
  }
}



// WEBPACK FOOTER //
// ./src/services/AccountsService.js